export const handleSearchInput = (filterObj, e) => {
    if (e.target.value === "") return;

    return e.target.value;
};

export const searchFilterHandler = (extensions, filterObj) => {
    if (!filterObj.value || !filterObj.targetProperty) return extensions;

    let { value, targetProperty } = filterObj;

    targetProperty = targetProperty.split(","); // We search in multiple properties

    return extensions.filter((extension) => {
        let includesSearchTerm = false;

        for (const prop of targetProperty) {
            if (
                extension[prop] &&
                value
                    .toLowerCase()
                    .split(" ")
                    .every((searchTerm) => extension[prop].toLowerCase().includes(searchTerm))
            ) {
                includesSearchTerm = true;
                break;
            }
        }

        return includesSearchTerm;
    });
};

const fillSearchInputValue = (filterEl, value) => {
    const filterValueEl = filterEl.querySelector(".el__filter-value");

    if (filterValueEl) filterValueEl.value = value;
};

export const setSearchInputValue = (filterEl, value) => fillSearchInputValue(filterEl, value);

export const resetSearchInputValue = (filterEl, value) => fillSearchInputValue(filterEl, "");
